import { Form, Input, Checkbox, FormProps, Select, FormInstance, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";

import { ChildForm, FieldDB, TabForm } from 'interfaces/schemaDB';
import { CrudFilters } from '@refinedev/core/dist/interfaces';
import Cw8Field from './Cw8Field';

// import {  } from '@refinedev/core/dist/interfaces';
// import { CrudFilter } from '@refinedev/core';
import { FormMode, ProviderTypes } from '../../../src/interfaces/interfaces';
// import moment from "moment-timezone";
import moment from 'moment'
import { config } from "config";
import Cw8List from "./Cw8List";
import Cw8FieldsForm from "./Cw8FieldsForm";
import Cw8TabsForm from "./Cw8TabsForm";
import { BaseKey, file2Base64 } from '@refinedev/core';
import { useCallback, useEffect, useRef } from "react";

interface Cw8FormProps{
    fieldList: FieldDB[]
    tabs ?: TabForm[] | null
    formProps : FormProps
    formMode : FormMode
    filterList?: CrudFilters | undefined
    record?: unknown
    resourceName : string
    form : FormInstance
    childrenForms?: ChildForm[]
    id?:string | BaseKey
    onFinish ?: (values:any) => void;
}





const Cw8Form = ({fieldList, tabs, formProps, filterList, record, formMode, resourceName, form, childrenForms, id, onFinish }: Cw8FormProps) => {
const saveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
const isAutoSave = useRef(false);
const lastSavedValuesRef = useRef<any>(form.getFieldsValue());
const subjectSpa = Form.useWatch("bv_dc_subject_spa", form);
const subjectEng = Form.useWatch("bv_dc_subject_eng", form);
const descripcion = Form.useWatch("bv_dc_descripcion", form);
const abstract = Form.useWatch("bv_abstract", form);

const obtenerKeywords = useCallback(async (descripcion: string, abstract: string) => {
  try {
    const currentValues = form.getFieldsValue([
      "bv_dc_subject_spa",
      "bv_dc_subject_eng",
    ]);

    if (currentValues.bv_dc_subject_spa?.trim() || currentValues.bv_dc_subject_eng?.trim()) {
      console.log("Ya existen keywords, no se sobreescriben.");
      return;
    }

    const [resSpa, resEng] = await Promise.all([
      fetch(`${config.urlAPI}/getKeyWords`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: descripcion }),
      }),
      fetch(`${config.urlAPI}/getKeyWords`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: abstract }),
      }),
    ]);

    if (!resSpa.ok || !resEng.ok) throw new Error("Error obteniendo keywords");

    const dataSpa = await resSpa.json();
    const dataEng = await resEng.json();

    form.setFieldsValue({
      bv_dc_subject_spa: dataSpa.data.keyWords,
      bv_dc_subject_eng: dataEng.data.keyWords,
    });
  } catch (error) {
    console.error("Error en keywords:", error);
  }
}, [form]);

useEffect(() => {
  if (descripcion?.trim() && abstract?.trim()) {
    // 👇 Solo si los dos keywords están vacíos
    if (!subjectSpa?.trim() && !subjectEng?.trim()) {
      obtenerKeywords(descripcion, abstract);
    }
  }
}, [descripcion, abstract, subjectSpa, subjectEng, obtenerKeywords]);

useEffect(() => {
  if (descripcion && abstract) {
    obtenerKeywords(descripcion, abstract);
  }
}, [descripcion, abstract]);

    const handleFormFinish = async (values: any) => {
    console.log("Valores enviados al formulario:", values);

    // Clonamos los valores y transformamos fechas si es necesario
    const transformedValues = { ...values };

    if (formMode === FormMode.create || formMode === FormMode.edit) {
        fieldList
            .filter((field) => field.type === "date")
            .forEach((field) => {
                if (transformedValues[field.name]?.$d) {
                    transformedValues[field.name] = moment(transformedValues[field.name].$d).format("YYYY-MM-DD");
                }
            });
    }

    // Obtenemos el usuario desde localStorage
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    // Agregamos campos manuales
    if (formMode === FormMode.create) {
        transformedValues.bv_usuario_insert = user.email ?? "";
        transformedValues.bv_usuario_modifica = user.email ?? "";
    } else if (formMode === FormMode.edit) {
        transformedValues.bv_usuario_modifica = user.email ?? "";
    }

    console.log("Valores enviados al formulario BD:", transformedValues);

    // Ejecutamos onFinish internos o externos
    if (formProps.onFinish) {
        await formProps.onFinish(transformedValues);
    }

    if (onFinish) {
        await onFinish(transformedValues);
    }
};


    return (
        
        <Form {...formProps} 
            labelCol={{
                span: 4,
            }}
            wrapperCol={{
                span: 14,
            }}
            layout="horizontal"        
            onValuesChange={(_, allValues) => {
    if (resourceName !== "bibliotecaVirtual") return;

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    const hasChanges = JSON.stringify(allValues) !== JSON.stringify(lastSavedValuesRef.current);

    if (hasChanges) {
      console.log("Cambios detectados, se espera 15s para autosave");
      saveTimeoutRef.current = setTimeout(() => {
        isAutoSave.current = true;
        form.submit();
      }, 5000);
    }
  }}
            
            onFinish={handleFormFinish}
            /*
            onFinish={ (values) => {
                
                console.log("OnFinish");                
                const base64Files = [];
                const { fro_obj } = values;

//                 for (const file of fro_obj) {
//                     if (file.originFileObj) {
//                         const base64String = await file2Base64(file);

//                         base64Files.push({
//                             ...file,
//                             base64String,
//                         });
//                     } else {
//                         base64Files.push(file);
//                     }
//                 }                
// console.log(base64Files);

                //transformar las fechas para enviarlas a airtable
                if( config.provider == ProviderTypes.airTable && formMode == FormMode.create){
                    fieldList.filter( field=>field.type=="date" ).forEach( field =>{
                        console.log(values[field.name].$d)
                        let tmp =  moment( values[field.name].$d ).format("YYYY-MM-DD")
                        values[field.name] = tmp
                    } )
                }
                return (
                    formProps.onFinish &&
                    formProps.onFinish({
                        ...values,
                        // fro_obj: base64Files,
                    })
                );
            }}
            */

            encType="multipart/form-data"
        >
        {
            tabs?(
                <Cw8TabsForm
                    fieldList = {fieldList}
                    tabs = {tabs}
                    filterList = {filterList}
                    record = {record}
                    formMode = {formMode}
                    resourceName = {resourceName}
                    form = {form}
                    childrenForms = {childrenForms}
                    id = {id}

                />
            ):(
                <Cw8FieldsForm
                    fieldList = {fieldList}
                    filterList = {filterList}
                    record = {record}
                    formMode = {formMode}
                    resourceName = {resourceName}
                    form = {form}
                    // id = {id}

                />

            )

            

            

        }
        </Form>
    )
}

export default Cw8Form
